<div class="calendar-container">
  <div *ngIf="events.length > 0">
    <div *ngFor="let event of events; let i = index">
      <div class="dt_header" id="{{(event.start.dateTime | date:'EEE_d_MMM')}}"
           *ngIf="(i == 0 || (events[i-1].start.dateTime | date:'EEE d MMM') != (event.start.dateTime | date:'EEE d MMM'))">
            <i class="fas fa-fw fa-calendar me-2"></i>{{(event.start.dateTime | date:'EEE d MMM')}}
      </div>
      <div class="event-item">
        <div class="p-1">
          <div class="row">
            <div class="col-12">
              <a class="ms-2" *ngIf="showAddButton" (click)="calToEntry(event)" href="" onclick="return false">{{ event.summary }}</a>
              <span class="ms-2" *ngIf="!showAddButton">{{ event.summary }}</span>
              <a class="mx-2" href="{{event.htmlLink}}" target="_blank">
                <i class="fas fa-fw c_blue fa-calendar p-1"></i>
              </a>
              <br />
              <span class="event-time ms-2">{{ event.start.dateTime | date: 'h:mm a' }} - {{ event.end.dateTime | date: 'h:mm a' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="events.length === 0" class="no-events">No upcoming events found.</div>
</div>
